import { Box, Button, Container, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useAuthContext } from 'src/auth/hooks';
import Iconify from 'src/components/iconify';
import { LoadingScreen } from 'src/components/loading-screen';
import { useSettingsContext } from 'src/components/settings';
import { RouterLink } from 'src/routes/components';
import { paths } from 'src/routes/paths';
import { getInterviewReports } from 'src/services/interview.service';
import { fetchJobOpenings } from 'src/services/role.service';
import { ReportsTable } from '../reports-table/reports-table';

export default function ReportsListView() {
  // context
  const { user } = useAuthContext();

  // states
  const [loader, setLoader] = useState(false);
  const [reports, setReports] = useState([]);

  // hooks
  const settings = useSettingsContext();

  // functions
  const getReports = () => {
    setLoader(true);
    getInterviewReports(user.organization_id)
      .then(res => {
        if (res.success) {
          const _reports = [];
          res.body.reportList.forEach(currentReport => {
            const _report = {
              id: currentReport.report_id,
              orgId: currentReport.organization_id,
              title: currentReport.report_title,
              reportStatus: currentReport.report_status,
              reportLink: currentReport.report_link,
              createdAt: currentReport.created_at,
              updatedAt: currentReport.updated_at,
            };

            _reports.push(_report);
          });

          setReports(_reports);
        } else throw new Error('Something went error');
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  useEffect(() => {
    getReports();
  }, []);

  return (
    <>
      {loader && <LoadingScreen loadingText="Reports List Loading..." />}
      {!loader && (
        <Container
          sx={{
            py: '42.5px',
            px: '40px',
          }}
          maxWidth={settings.themeStretch ? false : 'lg'}
        >
          <Stack
            spacing={1.5}
            direction="row"
            alignItems="center"
            sx={{
              mb: { xs: 3, md: 5 },
            }}
          >
            <Box sx={{ flexGrow: 1 }}>
              <Box sx={{ mb: '1rem' }}>
                <Typography variant="h2" fontWeight={600}>
                  Reports
                </Typography>
              </Box>
            </Box>
          </Stack>
          <ReportsTable reports={reports} />
        </Container>
      )}
    </>
  );
}
